import React, { useState, Fragment } from 'react'
import _ from 'lodash';

type FieldValues = {
  name: string, 
  label: string,
  error: any, 
  inputRef: any, 
  defaultValue: string,
  type?: string,
  maxlength?: number, 
  onChange: any, 
  onBlur?: any,
  isLoading?: boolean
};

const FieldText: React.FC<FieldValues> = ({ name, label, error, inputRef, defaultValue, type, maxlength, onChange, onBlur, isLoading }) => {
  const [fieldText, setFieldText] = useState(defaultValue);
  const [fieldFocus, setFieldFocus] = useState(false);
  const handleFocus = (e: any) => {
    setFieldFocus(true);
  }
  const handleBlur = (e: any) => {
    setFieldFocus(false);
    if (typeof onBlur == 'function'){
      onBlur(e);
    }
  }
  const handleChange = (e: any) => {
    setFieldText(e.target.value);
    onChange(e);
    if (e.nativeEvent.target != document.activeElement){
      handleBlur(e);
    }
  }
  return (
    <Fragment>
      <div className={'i-form-group ' + (isLoading ? 'i-form-group-loading' : '')}>
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        <input type={type || 'text'}
          id={name} 
          ref={inputRef} 
          onChange={handleChange} 
          onFocus={handleFocus} 
          onBlur={handleBlur} 
          defaultValue={defaultValue}
          maxLength={maxlength || undefined}
          disabled={isLoading}
        />
        <label htmlFor={name} className={`${fieldText || fieldFocus ? 'i-float' : ''}`}>
          {label}
        </label>
        {error ? <div className="i-form-group-text i-has-error">
          {error.message ? error.message : fieldText ? `${label} is an incorrect format` : `${label} is required`}
        </div> : ''}
      </div>
    </Fragment>
  )
}

export default FieldText
